<mode-filter-panel
  [showSetDefault]="showSettingsMenu"
  [filters]="filterControls$ | async"
  [filterOptions]="filterOptions$ | async"
  [isLoading]="datasetsLoading$ | async"
  [showSettingsMenu]="showSettingsMenu"
  [isFilterPanelOpen]="isFilterPanelOpen$ | async"
  [orphanedFilters]="orphanedFilters$ | async"
  [selectedOptCounts]="filterOptionSelectedCounts$ | async"
  [optCounts]="filterOptionCounts$ | async"
  [model]="model$ | async"
  [buttonPosition]="buttonPosition$ | async"
  (filtersApply)="onFiltersApply($event)"
  (filtersReset)="onFiltersReset($event)"
  (filterSelectionChange)="onFilterSelectionChange($event)"
></mode-filter-panel>
